import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-bg-muted', className)}
      {...props}
    />
  );
}

function SkeletonSpan({ className, ...props }: React.ComponentProps<'span'>) {
  return (
    <span
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-bg-muted', className)}
      {...props}
    />
  );
}

export { Skeleton, SkeletonSpan };
